import APP_CONFIG from 'src/config/AppConfig';
export const MEDICAL_REPORTS_VERSION = Object.freeze({
  V1: 'v1',
  V2: 'v2',
});
export const getCustomerMedicalReportLogo = (customerId: string) =>
  `https://reports-${APP_CONFIG.ENV}.neteera.com/medical-reports-data/assets/${customerId}/logo.svg`;

export const ACCESS_DENIED_PHI_PROTECTION = 'ACCESS_DENIED_PHI_PROTECTION';
